module.exports = __webpack_public_path__ + "img/a.6f48fbf5.jpg";